"use strict";

var ga = require('../ga.constants');
module.exports = /*@ngInject*/function ($location, ProfileService) {
  // eslint-disable-next-line no-var
  var ctrl = this;
  ctrl.profile = ProfileService.getProfile();
  ctrl.hasRoleInInspect = ProfileService.hasRoleInInspect();
  ctrl.canPerformInspection = ProfileService.isAdmin() || ProfileService.isInspector() || ProfileService.hasManagerInspection();
  ctrl.canAccessManagement = function () {
    return ProfileService.isAdmin() || ProfileService.isSuperUser();
  };
  ctrl.navButtons = [];
  if (ctrl.canPerformInspection) {
    ctrl.navButtons.push({
      title: 'Start Inspection',
      link: '#!/report-create',
      icon: 'uc-r-inspection pull-left'
    });
  }
  if (ctrl.hasRoleInInspect) {
    ctrl.navButtons.push({
      title: 'Inspection Reports',
      link: '#!/report',
      icon: 'glyphicon glyphicon-align-justify pull-left'
    });
  }
  if (ctrl.canAccessManagement()) {
    ctrl.navButtons.push({
      title: 'Management',
      link: '#!/management',
      icon: 'glyphicon glyphicon-cog pull-left'
    });
  }
  ctrl.getHomeNavigationEvent = function (label) {
    return [ga.categories.HOME_NAV_BUTTONS, ga.actions.NAVIGATE, label];
  };
  ctrl.events = {
    buttons: {
      'Inspection Reports': ctrl.getHomeNavigationEvent(ga.labels.REPORTS),
      'Open Findings': ctrl.getHomeNavigationEvent(ga.labels.OPEN_FINDINGS),
      Management: ctrl.getHomeNavigationEvent(ga.labels.MANAGEMENT)
    }
  };
};